import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';

import Button, { IconButton } from '@dbk/ui-buttons';
import Text from '@dbk/ui-text'
import { FormGroup, Message, Label } from '@dbk/ui-forms';
import { Close } from '@dbk/ui-icons';
import convertToBase64 from '../../../../utils/convert-to-base64';
import { DOC_UPLOAD } from '../../../../constants';
import docUpload from '../../../doc-sign-center/doc-upload';

class FileUpload extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fileTooBig: false,
      wrongFileFormat: false,
      file: null
    }


  }

  componentWillReceiveProps(props) {
    if (props && props.missingFile) {
      this.setState({
        fileTooBig: false,
        wrongFileFormat: false,
      })
    }
  }

  browseClickListener = () => {
    this.fileUploadInput.click();
  }

  async onChangeClicked(e) {
    if (this.isValidFile(e.target && e.target.files[0])) {
      // const fileData = e.target.files[0];
      // const base64Data = await convertToBase64(e.target.files[0])
      //TO DO: need to uncomment above line and comment hard code base64 data on environment.
      this.setState({
        fileTooBig: false,
      });
      this.props.onAttachFile(e.target.files[0]);
    } else {
      this.props.onAttachFile('');
    }

  }

  // onInputChange(e) {
  //   if (e.target && e.target.files[0]) {
  //     if (this.isValidFile(e.target.files[0])) {
  //       this.setState({
  //         fileTooBig: false,
  //         wrongFileFormat: false
  //       });
  //       this.props.onAttachFile(e.target.files[0])
  //     }
  //   }
  // }

  isValidFile(file) {
    const size = file.size; // size in bytes
    const name = file.name; // file name
    //const extension = name.substr(name.length - 3);

    let returnVal = true;
    const { app: { config: { uploadFileMaxSize } } } = this.props;

    if (size > (uploadFileMaxSize || DOC_UPLOAD.MAXSIZE)) {
      this.removeSelectedFile();
      this.setState({
        fileTooBig: true,
      });
      returnVal = false;
    }

    return returnVal;
  }

  removeSelectedFile = () => {
    this.fileUploadInput.value = '';
    if (!/safari/i.test(navigator.userAgent)) {
      this.fileUploadInput.type = ''
      this.fileUploadInput.type = 'file'
    }
    this.props.onAttachFile(null);
  }

  render() {
    const {
      i18n: { messages },
      file, docupload: { supportedExtension } }
      = this.props;
    const extension = supportedExtension.toString();
    return (
      <div className="docsigncenter large-12 margin-bottom-10 margin-top-20">
        <input
          ref={input => this.fileUploadInput = input}
          type="file"
          accept={extension}
          name="browseFileName"
          id="browseFile"
          className="doc-upload-inputfile"
          onChange={(e) => this.onChangeClicked(e)} />
        <Button
          tertiary
          className="doc-upload-browse-button"
          size="large"
          onClick={this.browseClickListener} >
          {messages['app.documentUpload.browseDocument.browseButton']}
        </Button>      
        {
          file &&
          <span className="doc-upload-browse-fileName">{file.name}</span>
        }
        {file && <IconButton
          className="browseUploadFile"
          onClick={this.removeSelectedFile}>
          <Close className="margin-bottom-10"color={'#999'} height={15} width={15} />
        </IconButton>}
        {this.state.fileTooBig && <Message testID="docUpload-modal-container-uploadFileButton-error" type="error">
          {messages['app.docUpload.fileTooBig']}
        </Message>}
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    app: {
      config: {
        uploadFileMaxSize: true
      },
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    docupload: {
      supportedExtension: true
    }
  }
})(FileUpload);

